module.exports = __webpack_public_path__ + "img/image (17).d0e6dc23.png";